import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { FC } from "react";
import { COLOR_GREY_6 } from "shared/theme/colors";

type FieldLabelType = {
  label?: string;
  labelColor?: string;
  fontWeight?: number;
};

const FieldLabel: FC<FieldLabelType> = ({
  label,
  labelColor,
  fontWeight,
  ...props
}) => {
  if (!label) {
    return null;
  }

  return (
    <Box display="flex" mb=".5rem">
      <Typography
        variant="bodySMedium"
        fontWeight={fontWeight ?? 400}
        color={labelColor ?? COLOR_GREY_6}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default FieldLabel;
